import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { useState, useEffect } from 'react'
import { $getRoot } from 'lexical'

export function PlaceholderPlugin({ placeholder }) {
  const [editor] = useLexicalComposerContext()
  const [isEmpty, setIsEmpty] = useState(true)

  useEffect(() => {
    const update = () => {
      editor.getEditorState().read(() => {
        setIsEmpty($getRoot().getTextContentSize() === 0)
      })
    }
    update()
    return editor.registerUpdateListener(() => update())
  }, [editor])

  if (!placeholder || !isEmpty) return null
  return (
    <div className="fdai-structured-placeholder" aria-hidden>
      {placeholder}
    </div>
  )
}
